import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type { PlatformSummary, PlatformSummaryQuery } from '../types';

/**
 * osprey-api `/reporting` (PE-2108 FE, PE-2091 backend). TCS-staff only
 * (CollectiveOnlyGuard) + `REPORTING.READ`, enforced server-side. Platform-level,
 * so not tenant-scoped.
 */
export const reportingApi = {
  getPlatformSummary: async (query: PlatformSummaryQuery = {}): Promise<PlatformSummary> => {
    const search = new URLSearchParams();
    if (query.from) search.append('from', query.from);
    if (query.to) search.append('to', query.to);
    const qs = search.toString();
    const response = await ApiFetch.get<Enveloped<PlatformSummary>>(
      `/reporting/platform-summary${qs ? `?${qs}` : ''}`,
    );
    return unwrap(response);
  },
};
